import { IAccDoiTuongKhongTinhHocPhiActionTypes } from "../../action-types/category/IDoiTuongKhongTinhHocPhiActions";
import { IDoiTuongKhongTinhHocPhiReducer } from "../../reducer-model/category/IDoiTuongKhongTinhHocPhiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDoiTuongKhongTinhHocPhiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  doiTuongKhongTinhHocPhis: [],
};
export const doiTuongKhongTinhHocPhiReducer = (
  state: IDoiTuongKhongTinhHocPhiReducer = iniState,
  action: IAccDoiTuongKhongTinhHocPhiActionTypes,
): IDoiTuongKhongTinhHocPhiReducer => {
  switch (action.type) {
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        doiTuongKhongTinhHocPhis: action.payload,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        doiTuongKhongTinhHocPhiEditing: action.payload,
      };
    case "DOI_TUONG_KHONG_TINH_HOC_PHI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        doiTuongKhongTinhHocPhiEditing: undefined,
      };
    default:
      return state;
  }
};
